import { Dropdown, FormControl, DropdownButton, Button } from 'react-bootstrap'
import { Component, useState, useEffect, useRef } from 'react'
import React from 'react';
import '../../../index.css'

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick, disabled = false }, ref) => (
    <Button
        disabled={disabled}
        variant="secondary"
        href=""
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        &#32;
        &#x25bc;
  </Button>
));

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
        const [value, setValue] = useState('');
        //console.log("DropDown Children: ")
        //console.log(React.Children.toArray(children))

        return (
            <div
                ref={ref}
                style={style}
                className={className}
                aria-labelledby={labeledBy}
            >
                <FormControl
                    ref={function (input) {
                        if (input != null) {
                            input.focus();
                        }
                    }}
                    autoFocus
                    className="mx-3 my-2 w-auto"
                    placeholder="Filtern..."
                    onChange={(e) => { console.log(e.target.value); setValue(e.target.value) }}
                    value={value}
                />
                <ul className="list-unstyled">
                    {React.Children.toArray(children).map(
                        (child) =>
                            (value && React.Children.toArray(child.props.children).filter(x => x.props != undefined && x.props.disabled == false
                               && x.props.children.toString().toLowerCase().includes(value.toLowerCase()))
                            ),
                    )}
                </ul>
                <ul className="list-unstyled">
                    {React.Children.toArray(children).filter(
                        (child) =>
                            (!value || child.props.disabled == false &&
                                (child.props.children[0].props.children.toLowerCase().includes(value.toString().toLowerCase()) )),
                    )}
                </ul>
            </div>
        );
    },
);


export { CustomMenu, CustomToggle }